import SessionInfoComponent from '../components/Sessions/SessionInfoComponent';
import {useParams} from "react-router-dom";

const SessionInfoPage = (props) => {
  let { sessionId } = useParams();
  return <SessionInfoComponent sessionId={sessionId}/>;
};

export default SessionInfoPage;
